import React from 'react'
import * as translationService from '../services/translationService'
import { Markdown, Modal, ModalBody } from '../components'
import PropTypes from 'prop-types'

class TacModal extends React.Component {
  constructor(props) {
    super(props)
  }

  static propTypes = {
    isOpen: PropTypes.boolean,
    onRequestClose: PropTypes.func,
    tac: PropTypes.any,
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.toggleModal} title={translationService.registerTacTitle()}>
        <ModalBody>{this.props.tac && <Markdown source={this.props.tac.content} />}</ModalBody>
      </Modal>
    )
  }
}

export default TacModal



// WEBPACK FOOTER //
// ./src/views/TacModal.js